import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { fetchFields, clearFields } from '../store/fieldsSlice';

const useFields = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { fields, loading, error } = useSelector(
    (state: RootState) => state.fields,
  );
  const { selectedHospital } = useSelector(
    (state: RootState) => state.hospitals,
  );

  useEffect(() => {
    if (selectedHospital?.tenantId) {
      // Always fetch fields when component mounts - fresh data every time
      dispatch(fetchFields(selectedHospital.tenantId));
    } else {
      // Clear fields if no hospital is selected
      dispatch(clearFields());
    }
  }, [dispatch, selectedHospital?.tenantId]);

  const refetchFields = () => {
    if (selectedHospital?.tenantId) {
      dispatch(fetchFields(selectedHospital.tenantId));
    }
  };

  return {
    fields,
    loading,
    error,
    refetchFields,
  };
};

export default useFields;
